// All the values that can be sent to the list exam endpoint to filter the exams we want to get
export enum ExamFilterEnum {
    ALL = 'all',
    FREE = 'free',               // Pas de session attribuée
    WAITING = 'waiting',         // Session attribuée, pas de candidat
    ASSIGNED = 'assigned',       // Session + candidat + session future
    TO_CHECK = 'to_check',       // Session passée + candidat + pas de fichiers d'examen
    TO_CORRECT = 'to_correct',   // Session passée + candidat + fichiers mais pas de résultats
    TO_VALIDATE = 'to_validate', // Résultats enregistrés mais pas locked
    CLOSED = 'closed',           // Locked
}
